module.exports = __webpack_public_path__ + "static/media/office.ec23df08.png";